import { PLATFORM } from '../platformConstants';
import activateNavConfig from './NavItems.json';
import activateIconMap from './IconMap';
import ActivateMenuBottom from './MenuBottom';

export const CURRENT_PLATFORM = PLATFORM.ACTIVATE;

const activateProvider = {
	platformId: CURRENT_PLATFORM,
	getCurrentPlatform: () => CURRENT_PLATFORM,
	getNavConfig: () => activateNavConfig,
	getIconMap: () => activateIconMap,
	getMenuBottom: () => ActivateMenuBottom
};

export default activateProvider;
